import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type PersonBasicInformation } from 'services'

export interface DuplicateResult {
  winner: PersonBasicInformation
  loser: PersonBasicInformation
  loser_has_positions: boolean
  loser_has_urls: boolean
  loser_has_phones: boolean
  loser_has_only_dangling_phones: boolean
  loser_has_addresses: boolean
  loser_has_only_dangling_addresses: boolean
}

interface SheetCell {
  value: string
  cell_link: string
}

export interface DuplicatePair {
  winner: SheetCell
  loser: SheetCell
}

export interface DuplicatesResponse {
  all_sheet_duplicate_pairs: DuplicatePair[]
  not_found_unique_ids: string[]
  associations: DuplicateResult[]
}

export async function getDuplicates (year: number, month: number): Promise<HttpResponse<DuplicatesResponse>> {
  return await handleHttpRequest(http.get(`/api/v1/people/duplicates/?year=${year}&month=${month}`))
}

export const deleteDuplicates = async (loserIds: number[], year: number, month: number): Promise<HttpResponse<void>> => {
  return await handleHttpRequest(http.delete(`/api/v1/people/duplicates/?year=${year}&month=${month}`, {
    data: { person_ids: loserIds }
  }))
}
